module.exports = __webpack_public_path__ + "static/homepage-b8004e9c3556707751a4fcfcef62330a.png";